module.exports = __webpack_public_path__ + "static/media/que-hacer-en-san-telmo.6567896a.md";